import _toConsumableArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import React, { useContext } from "react";
import { Box, Carousel, Container, Flex, Heading, IconClock } from "@catchoftheday/cg-components";
import { DEFAULT_APP_DOWNLOAD_LINK, PageConfigurationContext } from "@catchoftheday/common-vendors";
import { useMedia, useTheme } from "@catchoftheday/theme";
import { useOnePassShopUpcomingDealsQuery } from "@onepass-app/generated/graphql";
import { AppNudge } from "./AppNudge";
import { AppNudgeCard } from "./AppNudgeCard";
import { DealCard } from "./DealCard";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var ShopUpcomingDeals = function ShopUpcomingDeals() {
  var theme = useTheme();
  var isMobileScreen = useMedia(["(min-width: ".concat(theme.breakpoints.md, ")"), "(min-width: ".concat(theme.breakpoints.xs, ")")], [false, true]);

  var _useContext = useContext(PageConfigurationContext),
      pageConfig = _useContext.data;

  var _useOnePassShopUpcomi = useOnePassShopUpcomingDealsQuery(),
      upcomingDealsData = _useOnePassShopUpcomi.data;

  var _ref = upcomingDealsData || {},
      onePassUpcomingEntries = _ref.onePassUpcomingEntries;

  var _ref2 = onePassUpcomingEntries || {},
      entries = _ref2.entries;

  if (entries && (entries === null || entries === void 0 ? void 0 : entries.length) > 0) {
    var entriesToShow = entries.slice(0, 2);
    var noPrePromoteBanner = entriesToShow.some(function (deal) {
      var _deal$event, _deal$event$image;

      return !((_deal$event = deal.event) !== null && _deal$event !== void 0 && (_deal$event$image = _deal$event.image) !== null && _deal$event$image !== void 0 && _deal$event$image.onePassPrePromote);
    });

    if (noPrePromoteBanner) {
      return null;
    }

    var iosAppLink = (pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.footerItunesAppUrl) || (pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.itunesAppUrl);
    var androidAppLink = (pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.footerGooglePlayUrl) || (pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.googlePlayUrl);
    var desktopSlidesCount = entries.length > 1 ? 3 : 2;
    var slidesPerBreakpoint = [desktopSlidesCount, desktopSlidesCount, desktopSlidesCount, 1, 1];
    return ___EmotionJSX(Box, {
      py: {
        xs: "24px",
        md: "30px"
      },
      px: "10px",
      backgroundColor: "ui.backgroundColor"
    }, ___EmotionJSX(Flex, {
      alignItems: "center",
      justifyContent: "center",
      mb: {
        xs: "12px",
        md: "24px"
      }
    }, ___EmotionJSX(IconClock, {
      height: {
        xs: "16px",
        md: "20px"
      },
      color: "onePass.primaryDark"
    }), ___EmotionJSX(Heading.h3, {
      fontSize: {
        xs: "base",
        md: "xl"
      },
      lineHeight: "loose",
      color: "typography.text",
      m: 0,
      fontWeight: "normal",
      textAlign: "center"
    }, "Upcoming deals of the week")), ___EmotionJSX(Container, {
      display: "block",
      maxWidth: "1024px"
    }, ___EmotionJSX(Carousel, {
      showNavButtons: false,
      showBullets: isMobileScreen,
      slides: [].concat(_toConsumableArray(!isMobileScreen ? [___EmotionJSX(AppNudge, {
        key: "club-upcoming-deal-desktop-app-nudge"
      })] : []), _toConsumableArray(entriesToShow.map(function (entry, index) {
        var _entry$event, _entry$event2;

        return entry.event && ___EmotionJSX(DealCard, {
          "data-testid": "club-upcoming-deal-".concat((_entry$event = entry.event) === null || _entry$event === void 0 ? void 0 : _entry$event.id),
          key: "club-upcoming-deal-".concat((_entry$event2 = entry.event) === null || _entry$event2 === void 0 ? void 0 : _entry$event2.id),
          event: entry.event,
          startDate: entry.startDate,
          promote: entries.length > 1 && index === 0 && !isMobileScreen
        });
      })), _toConsumableArray(isMobileScreen ? [___EmotionJSX(AppNudgeCard, {
        key: "club-upcoming-deal-mobile-app-nudge",
        title: "Be the first to know when deals go live.",
        subtitle: "Download the Catch App and get notified",
        iosAppLink: iosAppLink || DEFAULT_APP_DOWNLOAD_LINK,
        androidAppLink: androidAppLink || DEFAULT_APP_DOWNLOAD_LINK
      })] : [])),
      slidesPerBreakpoint: slidesPerBreakpoint,
      step: 1,
      buttonOffset: [11, -10]
    })));
  }

  return null;
};
export default ShopUpcomingDeals;